module.exports = __webpack_public_path__ + "src/assets/games/37/BioTraceOceanWaves067.jpg";